import Loading from '../../../Common/Loading';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';
import { OcurrencesAnual } from './OcurrencesAnual';
import { OcurrencesMonth } from './OcurrencesMonth';

export const Charts = () => {
    const { isLoading } = useOcurrencesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <OcurrencesAnual />
                <OcurrencesMonth />
            </div>
        </>
    );
};
